/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import {
	InnerBlocks,
	store as blockEditorStore,
} from '@wordpress/block-editor';
import { compose } from '@wordpress/compose';
import { withSelect } from '@wordpress/data';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { updateBlockStyle } from './inline-styles';

import { name as buttonBlockName } from '../button';

const ALLOWED_BLOCKS = [ buttonBlockName ];
const LAYOUT = {
	type: 'default',
	alignments: [],
};

class edit extends Component {
	constructor( props ) {
		super( props );
		this.updateBlock = this.updateBlock.bind( this );
	}

	componentDidMount() {
		updateBlockStyle( {}, this.props );
	}

	updateBlock( data ) {
		const { setAttributes } = this.props;
		setAttributes( {
			...data,
		} );

		updateBlockStyle( data, this.props );
	}
	render() {
		const { attributes, className, preferredStyle, isSelected } = this.props;

		const { contentJustification, orientation } = attributes;
		return <div className={ classnames( className, {
			[ `is-content-justification-${ contentJustification }` ]: contentJustification,
			'is-vertical': orientation === 'vertical',
		}, 'wp-block-buttons' ) } >
			{ isSelected && <Inspector { ...this.props } /> }
			<InnerBlocks
				allowedBlocks={ ALLOWED_BLOCKS }
				template={ [
					[
						buttonBlockName,
						{ className: preferredStyle && `is-style-${ preferredStyle }` },
					],
				] }
				orientation={ orientation }
				__experimentalLayout={ LAYOUT }
				// templateInsertUpdatesSelection={ true }
			/>
		</div>;
	}
}

export default compose( [
	withSelect( ( select ) => {
		const preferredStyleVariations = select(
			blockEditorStore
		).getSettings().__experimentalPreferredStyleVariations;
		return {
			preferredStyle: preferredStyleVariations?.value?.[ buttonBlockName ],
		};
	} ),
] )( edit );
